import { sendGTMEvent } from '@next/third-parties/google';
import type { ReadonlyURLSearchParams } from 'next/navigation';

import {
  formatModelForFacebookTracking,
  trackFBLeadFinancial,
  trackFBLeadFinancialInitiated,
  trackFBLeadInterest,
  trackFBLeadInterestInitiated,
} from '@/tag-manager';

type QueryModelType = 'pickup' | 'ppv';

const getModelFromQueryParams = (
  params?: ReadonlyURLSearchParams
): QueryModelType => {
  if (!params) {
    return 'pickup';
  }

  const utm = params.get('utm_campaign');
  const model = params.get('model') as QueryModelType;

  if (model === 'ppv') {
    return 'ppv';
  }

  if (utm) {
    const loweredUTM = `${utm}`.toLowerCase();
    return loweredUTM.includes('mux') || loweredUTM.includes('mu-x')
      ? 'ppv'
      : 'pickup';
  }

  return 'pickup';
};

export interface TrackLeadInitiatedParams {
  campaignId: string;
  campaignName: string;
  type: string;
  queryParams?: ReadonlyURLSearchParams;
  selectedModel?: string;
}

export const trackLeadInitiated = ({
  campaignId,
  campaignName,
  type,
  queryParams,
  selectedModel,
}: TrackLeadInitiatedParams) => {
  sendGTMEvent({
    event: 'form-initiated',
    formId: campaignId,
    formName: campaignName,
  });
  if (type === 'financial') {
    trackFBLeadFinancialInitiated({ content_ids: selectedModel || '' });
  } else {
    trackFBLeadInterestInitiated({
      content_ids: getModelFromQueryParams(queryParams),
    });
  }
};

export interface TrackLeadSuccessParams {
  campaignId: string;
  campaignName: string;
  dealer: {
    district: string;
    province: string;
    name: string;
    branchCode: string;
  };
  type: string;
  queryParams?: ReadonlyURLSearchParams;
  selectedModel?: string;
}

export const trackLeadSuccess = ({
  campaignId,
  campaignName,
  queryParams,
  dealer,
  type,
  selectedModel,
}: TrackLeadSuccessParams) => {
  sendGTMEvent({
    event: 'form-success',
    formId: campaignId,
    formName: campaignName,
  });

  if (type === 'financial') {
    trackFBLeadFinancial({
      district: dealer.district,
      city: dealer.province,
      dealerName: dealer.name,
      id: dealer.branchCode,
      content_ids: selectedModel || campaignName,
    });
  } else {
    // interest
    const model = getModelFromQueryParams(queryParams);
    trackFBLeadInterest({
      district: dealer.district,
      city: dealer.province,
      dealerName: dealer.name,
      id: dealer.branchCode,
      content_ids: campaignName,
      model: formatModelForFacebookTracking(model),
    });
  }
};
